<template>
  <v-dialog
      v-model="dialog"
      :width="dialogWidth"
      @keydown.enter.prevent="save"
  >
    <v-card
        class="resizable-card"
        :class="{ 'no-select': resizing }"
        :style="{ height: dialogHeight + 'px' }"
    >
      <v-card-title>
        <span class="headline">Guard Config</span>
      </v-card-title>
      <v-card-text class="resizable-card__body">
        <v-row dense>
          <v-col cols="12" sm="2" md="2">
            <r-range :model.sync="model.level" label="Level:"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-3">
          <r-guard-rules :items.sync="model.allow" :anyof.sync="model.allowAnyOf" title="Allow"/>
        </v-row>
        <v-row dense>
          <v-divider/>
        </v-row>
        <v-row dense>
          <r-guard-rules :items.sync="model.block" :anyof.sync="model.blockAnyOf" title="Block"/>
        </v-row>
        <v-row dense>
          <v-divider/>
        </v-row>
        <v-row dense class="mt-2">
          <v-col cols="12" sm="6" md="6">
            <v-btn
                v-if="!isEmptyArray(model.offersAllow)"
                @click="onOffersAllow"
                small
                color="success"
                class="my-1 fill-width"
            >
              Offers Allow
            </v-btn>
            <v-btn
                v-else
                @click="onOffersAllow"
                small
                outlined
                color="primary"
                class="my-1 fill-width"
            >
              Offers Allow
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-btn
                v-if="!isEmptyArray(model.offersBlock)"
                @click="onOffersBlock"
                small
                color="success"
                class="my-1 fill-width"
            >
              Offers Block
            </v-btn>
            <v-btn
                v-else
                @click="onOffersBlock"
                small
                outlined
                color="primary"
                class="my-1 fill-width"
            >
              Offers Block
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="resizable-card__actions">
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>Cancel</v-btn>
        <v-btn @click="save" color="blue darken-1" text>Save</v-btn>
      </v-card-actions>
      <div class="resize-handle" @mousedown="startResize"></div>
    </v-card>

    <r-smart-offer-table-dialog ref="smart-offer-table-dialog"/>
  </v-dialog>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {GuardConfig} from "@/modules/redactor/models/guard/GuardConfig";

import RRange from "@/modules/redactor/views/utils/r-range";
import RGuardRules from "@/modules/redactor/views/guard/r-guard-rules";
import RSmartOfferTableDialog from "@/modules/redactor/views/smart-offer/r-smart-offer-table-dialog.vue";

export default {
  name: "r-guard-dialog",
  components: {RSmartOfferTableDialog, RGuardRules, RRange},

  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: VueTypes.objectOf(GuardConfig),
    rules: ViewRules.READONLY,
    dialogWidth: 633,
    dialogHeight: 546,
    resizing: false,
    resizeStartX: 0,
    resizeStartY: 0,
    resizeStartWidth: 633,
    resizeStartHeight: 546,
    viewportPadding: 32
  }),
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new GuardConfig();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.empty()) {
        this.resolve && this.resolve(null);
        this.discard();
      } else if (this.model.valid()) {
        this.resolve && this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject && this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
      this.stopResize();
    },

    onOffersAllow() {
      this.$refs["smart-offer-table-dialog"]
          .show(ViewRules.UPDATE, this.model.offersAllow, "Offers Allow")
          .then(result => {
            this.model.offersAllow = result.map(i => i.uid);
          }, () => {});
    },
    onOffersBlock() {
      this.$refs["smart-offer-table-dialog"]
          .show(ViewRules.UPDATE, this.model.offersBlock, "Offers Block")
          .then(result => {
            this.model.offersBlock = result.map(i => i.uid);
          }, () => {});
    },
    isEmptyArray(data) {
      return !data || data.length === 0;
    },

    startResize(e) {
      this.resizing = true;
      this.resizeStartX = e.clientX;
      this.resizeStartY = e.clientY;
      this.resizeStartWidth = this.dialogWidth;
      this.resizeStartHeight = this.dialogHeight;
      window.addEventListener("mousemove", this.onResize);
      window.addEventListener("mouseup", this.stopResize);
    },
    onResize(e) {
      if (!this.resizing) return;
      const dx = e.clientX - this.resizeStartX;
      const dy = e.clientY - this.resizeStartY;
      let newWidth = this.resizeStartWidth + dx;
      let newHeight = this.resizeStartHeight + dy;
      const minWidth = 480;
      const minHeight = 360;
      const maxWidth = window.innerWidth - this.viewportPadding;
      const maxHeight = window.innerHeight - this.viewportPadding;
      if (newWidth < minWidth) newWidth = minWidth;
      if (newWidth > maxWidth) newWidth = maxWidth;
      if (newHeight < minHeight) newHeight = minHeight;
      if (newHeight > maxHeight) newHeight = maxHeight;
      this.dialogWidth = newWidth;
      this.dialogHeight = newHeight;
    },
    stopResize() {
      if (!this.resizing) return;
      this.resizing = false;
      window.removeEventListener("mousemove", this.onResize);
      window.removeEventListener("mouseup", this.stopResize);
    }
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.onResize);
    window.removeEventListener("mouseup", this.stopResize);
  }
}
</script>

<style lang="css" scoped>
.fill-width {
  width: 100%;
}
.resizable-card {
  position: relative;
  display: flex;
  flex-direction: column;
}
.resizable-card__body {
  flex: 1;
  overflow: auto;
}
.resizable-card__actions {
  flex-shrink: 0;
}
.resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 14px;
  height: 14px;
  cursor: se-resize;
  border-right: 2px solid rgba(0, 0, 0, 0.3);
  border-bottom: 2px solid rgba(0, 0, 0, 0.3);
}
.no-select {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>